import { Link } from 'react-router-dom';

export function Brand() {
  return (
    <Link className="wf-brand" to="/" aria-label="Waterfall home">
      <span aria-hidden="true">W</span>aterfall
    </Link>
  );
}
